export function consoleError(...args: unknown[]) {
  if (process.env.REACT_APP_STAGE !== 'live') {
    // eslint-disable-next-line no-console -- need it here
    console.error(...args);
  }
}
